import { Component, Injector, OnInit } from '@angular/core';
import { map } from 'rxjs';
import { ListingBaseComponent } from 'src/app/shared/components/base/listing-base.component';
import { UserService } from 'src/app/shared/services';

@Component({
  selector: 'app-top-cashouts',
  templateUrl: './top-cashouts.component.html',
  styleUrls: ['./top-cashouts.component.scss'],
})
export class TopCashoutsComponent
  extends ListingBaseComponent
  implements OnInit
{
  TOP_CASH_OUTS_LOCATIONS: any = [];
  TOP_PAYMENTS_LOCATIONS: any = [];

  constructor(injector: Injector, public userService: UserService) {
    super(injector);
  }

  ngOnInit(): void {
    this.getTopCashout();
    this.getTopPayments();
  }

  getTopCashout() {
    this.dataService
      .fetchData({
        apiUrl: this.apiList.TOP_CASH_OUT_LOC,
        method: 'GET',
        contentType: 'application/json',
      })
      .pipe(
        map((response) => {
          return response ? response : null;
        })
      )
      .subscribe((response: any) => {
        this.TOP_CASH_OUTS_LOCATIONS =
          response?.top_completed_cash_out_locations.map((item: any) => ({
            ...item,
            name: item.name,
            address: item.address,
            currency: item?.cashout_sum?.currency,
            cashoutSum: Number(item?.cashout_sum?.value).toFixed(2),
          }));
      });
  }

  getTopPayments() {
    this.dataService
      .fetchData({
        apiUrl: this.apiList.TOP_PAYMENTS_LOC,
        method: 'GET',
        contentType: 'application/json',
      })
      .pipe(
        map((response) => {
          return response ? response : null;
        })
      )
      .subscribe((response: any) => {
        this.TOP_PAYMENTS_LOCATIONS =
          response?.top_processed_payment_locations.map((item: any) => ({
            ...item,
            name: item.name,
            address: item.address,
            currency: item?.payment_sum?.currency,
            paymentSum: Number(item?.payment_sum?.value).toFixed(2),
          }));
      });
  }
}
